import { StudentMaster } from './StudentMaster.model'
import { User } from './User.model'

export class NotificationMaster {
    public notificationId:number;
    public title:string;
    public message:string;
    
    public toUser:User;
    public toUserId:number;
    public type:string;
}